import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-map/jb-ref-map.ts
import { Spaceable } from "@bjb/bjb-web-components/dist/mixins";
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";

// src/components/jb-ref-map/jb-ref-map.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_map_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
h2, .subtitle {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h2 {
  font-size: var(--theme-typo-h2-section-title-mobile-fontsize, 1.5rem);
  font-weight: var(--theme-typo-h2-section-title-fontweight, var(--theme-font-light-weight, 300));
  letter-spacing: var(--theme-typo-h2-section-title-mobile-letterspacing, 0.125rem);
  line-height: var(--theme-typo-h2-section-title-mobile-lineheight, 2.25rem);
}

@media (min-width: 1281px) {
  h2 {
    font-size: var(--theme-typo-h2-section-title-desktop-fontsize, 1.938rem);
    letter-spacing: var(--theme-typo-h2-section-title-desktop-letterspacing, 0.25rem);
    line-height: var(--theme-typo-h2-section-title-desktop-lineheight, 2.5rem);
  }
}
.subtitle {
  font-size: var(--theme-typo-p-mobile-fontsize, 1.063rem);
  font-weight: var(--theme-typo-p-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-p-mobile-lineheight, 1.875rem);
}

@media (min-width: 1281px) {
  .subtitle {
    font-size: var(--theme-typo-p-desktop-fontsize, 1.188rem);
    line-height: var(--theme-typo-p-desktop-lineheight, 2.125rem);
  }
}
:host {
  --_row-small-margin: var(--theme-row-small-margin, 6.68%);
  --_row-medium-margin: var(--theme-row-medium-margin, 6.955%);
  --_row-large-margin: var(--theme-row-large-margin, 8.35%);
  --_row-width: var(--theme-row-width, calc(100% - (2 * var(--_row-small-margin))));
  display: grid;
  grid-template-columns: [full-start] minmax(0, 1fr) [main-start] minmax(0, var(--_row-width)) [main-end] minmax(0, 1fr) [full-end];
  margin-inline: auto;
}

@media (min-width: 600px) {
  :host {
    --_row-width: var(--theme-row-width, calc(100% - (2 * var(--_row-large-margin))));
  }
}
@media (min-width: 960px) {
  :host {
    --_row-width: var(--theme-row-width, calc(100% - (2 * var(--_row-medium-margin))));
  }
}
@media (min-width: 1437px) {
  :host {
    --_row-width: var(--theme-row-width, 1437px);
  }
}
.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

:host {
  width: 100%;
}

h2 + .subtitle,
h2 + .map,
.subtitle + .map {
  margin-top: var(--theme-spacing-lm);
}

h2 {
  color: #141e55;
  text-align: center;
  text-transform: uppercase;
  grid-column: main;
}

.subtitle {
  color: #141e55;
  text-align: center;
  grid-column: main;
}

.map {
  grid-column: full;
  aspect-ratio: 16/9;
}
@media (min-width: 960px) {
  .map {
    aspect-ratio: 2/1;
  }
}
@media (min-width: 1281px) {
  .map {
    grid-column: main;
  }
}`;

// src/components/jb-ref-map/jb-ref-map.ts
var JbRefMap = class extends Spaceable(LitElement) {
  constructor() {
    super(...arguments);
    this.circleRadius = 100;
    this.mapInitialZoom = 17;
  }
  async firstUpdated() {
    const script = document.createElement("script");
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=window.initMap&libraries=maps,marker&v=3.57`;
    document.head.appendChild(script);
    window.mapOptions = {
      apiKey: this.apiKey,
      center: this.location,
      circleRadius: this.circleRadius,
      mapId: this.mapId,
      mapInitialZoom: this.mapInitialZoom,
      // Legacy Google Maps styling: https://mapstyle.withgoogle.com/
      style: [
        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
        { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] }
      ]
    };
    const el = this.renderRoot.querySelector(".map");
    async function initMap() {
      const { Map: GMMap, Circle: GMCircle } = await window.google.maps.importLibrary("maps");
      const map = new GMMap(el, {
        center: window.mapOptions.center,
        disableDefaultUI: true,
        keyboardShortcuts: false,
        mapId: window.mapOptions.mapId,
        styles: window.mapOptions.mapId ? void 0 : window.mapOptions.style,
        zoom: window.mapOptions.mapInitialZoom || 17
      });
      new GMCircle({
        center: window.mapOptions.center,
        fillColor: "rgb(176, 170, 126)",
        fillOpacity: 0.4,
        map,
        radius: window.mapOptions.circleRadius || 100,
        strokeColor: "rgb(176, 170, 126)",
        strokeOpacity: 1,
        strokeWeight: 1
      });
    }
    window.initMap = initMap;
  }
  _getContentSpacingProperties() {
    return {
      horizontal: "full-width",
      grid: true,
      colsMdUp: "none"
    };
  }
  _renderMap() {
    if (!this.location || !this.location.lat || !this.location.lng) return nothing;
    return html`<div class="map"></div>`;
  }
  render() {
    return html`
      ${this.headline ? html`<h2>${this.headline}</h2>` : ""}
      ${this.subtitle ? html`<p class="subtitle">${this.subtitle}</p>` : ""} ${this._renderMap()}
    `;
  }
};
JbRefMap.styles = unsafeCSS(jb_ref_map_default);
__decorateClass([
  property()
], JbRefMap.prototype, "apiKey", 2);
__decorateClass([
  property({ type: Number })
], JbRefMap.prototype, "circleRadius", 2);
__decorateClass([
  property()
], JbRefMap.prototype, "headline", 2);
__decorateClass([
  property({ type: Object })
], JbRefMap.prototype, "location", 2);
__decorateClass([
  property()
], JbRefMap.prototype, "mapId", 2);
__decorateClass([
  property({ type: Number })
], JbRefMap.prototype, "mapInitialZoom", 2);
__decorateClass([
  property()
], JbRefMap.prototype, "subtitle", 2);
JbRefMap = __decorateClass([
  customElement("jb-ref-map")
], JbRefMap);

export {
  JbRefMap
};
